import 'select2'
import 'select2/dist/css/select2.css'

$(function () {
  // クリニック切替
  $('#js-hospital-stmc-code').select2({
    dropdownAutoWidth: true,
    language: {"noResults": function(){ return "選択肢はありません";}},
  }).on('select2:select', (e) => {
    $(e.target).closest("form").submit();
  });

  // LINE一斉配信モーダル
  $('#lineOfficialPage .btn-confirm').on('click', () => {
    $('#lineOfficialPage').modal('hide');
  });
})
